export default function PageTitle({
  title,
  createdAt,
}: {
  createdAt: string;
  title: string;
}) {
  return (
    <div className="flex flex-col items-center space-y-4 pb-8 md:pb-16 ">
      <div className="text-sm text-gray-500 dark:text-gray-400">
        {createdAt}
      </div>
      <h1 className="text-center text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-5xl md:leading-14 py-9">
        {title}
      </h1>
      <div className="w-96 h-0.5 bg-gray-200 dark:bg-gray-700" />
    </div>
  );
}
